export default __webpack_public_path__ + "5227eb62b23905060cc74d46d208cbd3.svg";